import { render, staticRenderFns } from "./systemPage.vue?vue&type=template&id=22bef66e"
import script from "./systemPage.vue?vue&type=script&lang=js"
export * from "./systemPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports